import type { Chess } from "chess.js";

const getWinner = (chess: Chess): "w" | "b" | undefined => {
    if (chess.isCheckmate()) {
        return chess.turn() === "w" ? "b" : "w";
    }

    return undefined;
};

const parseClockTime = (comment: string): string | undefined => {
    const match = comment.match(/\[%clk ([^\]]+)\]/);

    if (!match) {
        return undefined;
    }
    const result = match[1];

    if (!result) {
        return undefined;
    }
    return result;
};

export const ChessUtil = { getWinner, parseClockTime };
